import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography
} from "@mui/material";
import React from "react";
import Section from "./Section";

function Item({ imgSrc, title, description }) {
  return <>
    <Grid size={{ xs: 12, sm: 4 }}>
      <Card square sx={{ height: '100%' }}>
        <CardMedia
          sx={{ height: { xs: 220, sm: 140 } }}
          image={imgSrc}
          title={title}
        />
        <CardContent>
          <Typography gutterBottom variant="subtitle1" >
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" textAlign={"justify"}>
            {description}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </>
}
function Projekty() {

  return (
    <Section>
      <Container maxWidth="md" sx={{
        marginBottom: 3,
      }}>
        <Typography variant="h5" gutterBottom fontWeight='bold'>
          Projekty
        </Typography>
        <Grid container
          alignItems={"stretch"}
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          justifyContent={"space-between"}
        >
          <Item imgSrc={"/projects/apartments.png"}
            title={"Architektura kubaturowa"}
            description={<>
              Projektuję budynki, które funkcjonują w czasie i przestrzeni.
              Zrównoważone, osadzone, przemyślane.
            </>} />
          <Item imgSrc={"/projects/interior.png"}
            title={"Wnętrza"}
            description={<>
              Tworzę wnętrza, w których komfort spotyka estetykę.
              Z dbałością o detal i doświadczenia użytkownika.
            </>} />
          <Item imgSrc={"/projects/port.png"}
            title={"Zagospodarowanie terenu"}
            description={<>
              Kształtuję przestrzenie, które budują strukturę, spójność i jakość życia.
            </>} />
        </Grid>
      </Container>
    </Section>
  );
}

export default Projekty;
